export default "__VITE_ASSET__o3asXo4A__"